import { ReactiveController, ReactiveControllerHost } from "lit";
import type { AppState } from "../models";

const MAX_HISTORY = 50;

export class UndoController implements ReactiveController {
  private _past: AppState[] = [];
  private _future: AppState[] = [];

  get canUndo() { return this._past.length > 0; }
  get canRedo() { return this._future.length > 0; }

  constructor(private host: ReactiveControllerHost) {
    host.addController(this);
  }

  hostConnected() {}
  hostDisconnected() {}

  push(current: AppState) {
    this._past.push(current);
    if (this._past.length > MAX_HISTORY) this._past.shift();
    this._future = [];
    this.host.requestUpdate();
  }

  undo(current: AppState): AppState | null {
    if (!this.canUndo) return null;
    const prev = this._past.pop()!;
    this._future.unshift(current);
    this.host.requestUpdate();
    return prev;
  }

  redo(current: AppState): AppState | null {
    if (!this.canRedo) return null;
    const next = this._future.shift()!;
    this._past.push(current);
    this.host.requestUpdate();
    return next;
  }
}
